import { styled, Box } from "@material-ui/core";
import { rem } from "polished";

const StyledTutoring = styled(Box)(({ theme }) => ({
  padding: `0`,
}));

export { StyledTutoring };
